module.exports = __webpack_public_path__ + "static/media/win-icon.0e6f244c.png";